/**
 * Google Analytics 4 Integration for CoandaCloud
 * Tracks page views, user events, and conversions
 */

// GA4 Measurement ID
const GA_MEASUREMENT_ID = 'G-D1Z7PS1YSM';

// Initialize Google Analytics
(function initGoogleAnalytics() {
  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: true,
    cookie_flags: 'SameSite=None;Secure'
  });

  console.log('[Analytics] Google Analytics initialized');
})();

// Analytics helper functions
window.Analytics = {
  /**
   * Track custom events
   */
  trackEvent(eventName, eventParams = {}) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, eventParams);
      console.log('[Analytics] Event:', eventName, eventParams);
    }
  },

  /**
   * Track page views (for SPA navigation)
   */
  trackPageView(pagePath, pageTitle) {
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', {
        page_path: pagePath,
        page_title: pageTitle
      });
    }
  },

  /**
   * Track user signup
   */
  trackSignup(method = 'email') {
    this.trackEvent('sign_up', { method });
  },

  /**
   * Track user login
   */
  trackLogin(method = 'email') {
    this.trackEvent('login', { method });
  },

  /**
   * Track file upload
   */
  trackFileUpload(fileType, fileSize) {
    this.trackEvent('file_upload', {
      file_type: fileType,
      file_size_mb: Math.round(fileSize / (1024 * 1024) * 100) / 100
    });
  },

  /**
   * Track share link creation
   */
  trackShareLink(linkType = 'public', expiryHours = null) {
    this.trackEvent('share_link_created', {
      link_type: linkType,
      expiry_hours: expiryHours
    });
  },

  /**
   * Track visualization session
   */
  trackVisualization(dataType, features = []) {
    this.trackEvent('visualization_opened', {
      data_type: dataType,
      features_used: features.join(',')
    });
  },

  /**
   * Track filter usage
   */
  trackFilter(filterName) {
    this.trackEvent('filter_used', {
      filter_name: filterName
    });
  },

  /**
   * Track shared link access (when someone views a shared visualization)
   */
  trackSharedLinkAccess(caseName, sessionId, role = 'viewer') {
    this.trackEvent('shared_link_accessed', {
      case_name: caseName,
      session_id: sessionId,
      guest_role: role
    });
  },

  /**
   * Track conversion (plan upgrade)
   */
  trackConversion(planId, value) {
    this.trackEvent('purchase', {
      transaction_id: Date.now().toString(),
      value: value,
      currency: 'USD',
      items: [{
        item_id: planId,
        item_name: planId
      }]
    });
  },

  /**
   * Set user properties
   */
  setUserProperties(userId, userType = 'free') {
    if (typeof gtag === 'function') {
      gtag('config', GA_MEASUREMENT_ID, {
        user_id: userId,
        user_properties: {
          account_type: userType
        }
      });
    }
  }
};
